import { User } from 'types/User';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  userDetails?: User;
}

export const initialUserState: UserState = {
  userDetails: undefined,
};

/**
 * The redux reducer used for user state management.
 */
const userSlice = createSlice({
  name: 'USER',
  initialState: initialUserState,
  reducers: {
    initUser: (state, action: PayloadAction<User>) => {
      return { ...state, userDetails: action.payload };
    },
    updateUser: (state, action: PayloadAction<User>) => {
      return { ...state, userDetails: action.payload };
    },
  },
});

export const { initUser, updateUser } = userSlice.actions;

export default userSlice.reducer;
